import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Modal from 'components/common/Modal'
import Text from 'components/common/Text/Text'
import Mixin from 'components/common/Mixin'
import Button from 'components/common/Button/Button'

const AppointmentChangeModal = ({ handleHide, message, navigateBack }) =>
  <CustomModal title="Appointment Change" closeHandler={ handleHide }>
    <Text block lineheight={ 1.5 }>
      { message }
    </Text>
    <ViewButton full="mobile" onClick={ navigateBack }>Go Back</ViewButton>
  </CustomModal>

export default AppointmentChangeModal

AppointmentChangeModal.propTypes = {
  handleHide: PropTypes.func,
  message: PropTypes.string,
  navigateBack: PropTypes.func
}

const CustomModal = styled(Modal)`
  overflow-y: auto;
  ${Mixin.responsive('padding', '25px 24px 30px', '60px 16px 40px')}
`

const ViewButton = styled(Button)`
  ${Mixin.responsive('margin-top', '15px', '20px')}
`
